/**
 * @generated SignedSource<<8a6750eba89f00791d37df4819357191>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type pricingPageRelayQuery$variables = {
  limit?: number | null | undefined;
  locale: string;
  pricingTitleInternal?: string | null | undefined;
  productNameId: string;
  skipSeoFields?: boolean | null | undefined;
};
export type pricingPageRelayQuery$data = {
  readonly pricingCollection: {
    readonly items: ReadonlyArray<{
      readonly additionalDetailsCollection: {
        readonly items: ReadonlyArray<{
          readonly planAdditionalDetails: {
            readonly json: any;
          } | null | undefined;
          readonly planAdditionalDetailsTitleExternal: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly callToActionContainerCollection: {
        readonly items: ReadonlyArray<{
          readonly ctaAsset?: {
            readonly description: string | null | undefined;
            readonly title: string | null | undefined;
            readonly url: string | null | undefined;
          } | null | undefined;
          readonly ctaButtonText?: string | null | undefined;
          readonly ctaMicrocopyTitleExternal?: string | null | undefined;
          readonly ctaText?: string | null | undefined;
          readonly ctaTitleExternal?: string | null | undefined;
          readonly ctaUrl?: string | null | undefined;
          readonly valueProposition?: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly compareFeaturesCollection: {
        readonly items: ReadonlyArray<{
          readonly featureGroupTitleExternal: string | null | undefined;
          readonly featuresCollection: {
            readonly items: ReadonlyArray<{
              readonly callOut: string | null | undefined;
              readonly description: {
                readonly json: any;
              } | null | undefined;
              readonly featureAdditionalInformationCollection: {
                readonly items: ReadonlyArray<{
                  readonly featureAdditionalInformation: string | null | undefined;
                  readonly relevantPlanCollection: {
                    readonly items: ReadonlyArray<{
                      readonly planTitleExternal: string | null | undefined;
                    } | null | undefined>;
                  } | null | undefined;
                } | null | undefined>;
              } | null | undefined;
              readonly featureNameExternal: string | null | undefined;
              readonly relevantPlanCollection: {
                readonly items: ReadonlyArray<{
                  readonly planTitleExternal: string | null | undefined;
                } | null | undefined>;
              } | null | undefined;
              readonly relevantUrl: string | null | undefined;
            } | null | undefined>;
          } | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly compareFeaturesTitle: string | null | undefined;
      readonly comparePlansCollection: {
        readonly items: ReadonlyArray<{
          readonly highlightedFeaturesContainerCollection: {
            readonly items: ReadonlyArray<{
              readonly callOut: string | null | undefined;
              readonly highlightedFeatureDetails: {
                readonly json: any;
              } | null | undefined;
              readonly highlightedFeatureTitleExternal: string | null | undefined;
            } | null | undefined>;
          } | null | undefined;
          readonly highlightedFeaturesTitle: string | null | undefined;
          readonly microCtaCollection: {
            readonly items: ReadonlyArray<{
              readonly ctaButtonText?: string | null | undefined;
              readonly ctaMicrocopyTitleExternal?: string | null | undefined;
              readonly ctaUrl?: string | null | undefined;
            } | null | undefined>;
          } | null | undefined;
          readonly planOneLiner: string | null | undefined;
          readonly planTitleExternal: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly datacenterPlansCollection: {
        readonly items: ReadonlyArray<{
          readonly highlightedFeaturesContainerCollection: {
            readonly items: ReadonlyArray<{
              readonly callOut: string | null | undefined;
              readonly highlightedFeatureDetails: {
                readonly json: any;
              } | null | undefined;
              readonly highlightedFeatureTitleExternal: string | null | undefined;
            } | null | undefined>;
          } | null | undefined;
          readonly highlightedFeaturesTitle: string | null | undefined;
          readonly microCtaCollection: {
            readonly items: ReadonlyArray<{
              readonly ctaButtonText?: string | null | undefined;
              readonly ctaMicrocopyTitleExternal?: string | null | undefined;
              readonly ctaUrl?: string | null | undefined;
            } | null | undefined>;
          } | null | undefined;
          readonly planOneLiner: string | null | undefined;
          readonly planTitleExternal: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly getMoreDetailsTitle: string | null | undefined;
      readonly headline: {
        readonly json: any;
      } | null | undefined;
      readonly pageDescription?: string | null | undefined;
      readonly pricingTitleExternal?: string | null | undefined;
      readonly pricingTitleInternal: string | null | undefined;
      readonly relatedProductCollection: {
        readonly items: ReadonlyArray<{
          readonly productName: string | null | undefined;
          readonly productNameId: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
    } | null | undefined>;
  } | null | undefined;
};
export type pricingPageRelayQuery = {
  response: pricingPageRelayQuery$data;
  variables: pricingPageRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 1,
  "kind": "LocalArgument",
  "name": "limit"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locale"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pricingTitleInternal"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productNameId"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skipSeoFields"
},
v5 = [
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "locale",
    "variableName": "locale"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "pricingTitleInternal_contains",
        "variableName": "pricingTitleInternal"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "productNameId_contains",
            "variableName": "productNameId"
          }
        ],
        "kind": "ObjectValue",
        "name": "relatedProduct"
      }
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pricingTitleInternal",
  "storageKey": null
},
v7 = {
  "condition": "skipSeoFields",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pricingTitleExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageDescription",
      "storageKey": null
    }
  ]
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "json",
    "storageKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "PricingHeadline",
  "kind": "LinkedField",
  "name": "headline",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 10
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "planTitleExternal",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "planOneLiner",
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 15
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaUrl",
  "storageKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaMicrocopyTitleExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaButtonText",
      "storageKey": null
    },
    (v14/*: any*/)
  ],
  "type": "CallToActionMicrocopy",
  "abstractKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "highlightedFeaturesTitle",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "callOut",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": (v13/*: any*/),
  "concreteType": "PlanHighlightedFeaturesContainerCollection",
  "kind": "LinkedField",
  "name": "highlightedFeaturesContainerCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HighlightedFeature",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "HighlightedFeatureHighlightedFeatureDetails",
          "kind": "LinkedField",
          "name": "highlightedFeatureDetails",
          "plural": false,
          "selections": (v8/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "highlightedFeatureTitleExternal",
          "storageKey": null
        },
        (v17/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "highlightedFeaturesContainerCollection(limit:15)"
},
v19 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Plan",
    "kind": "LinkedField",
    "name": "items",
    "plural": true,
    "selections": [
      (v11/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": (v13/*: any*/),
        "concreteType": "PlanMicroCtaCollection",
        "kind": "LinkedField",
        "name": "microCtaCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v15/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "microCtaCollection(limit:15)"
      },
      (v16/*: any*/),
      (v18/*: any*/)
    ],
    "storageKey": null
  }
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "compareFeaturesTitle",
  "storageKey": null
},
v21 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Plan",
    "kind": "LinkedField",
    "name": "items",
    "plural": true,
    "selections": [
      (v11/*: any*/)
    ],
    "storageKey": null
  }
],
v22 = {
  "alias": null,
  "args": (v10/*: any*/),
  "concreteType": "PricingCompareFeaturesCollection",
  "kind": "LinkedField",
  "name": "compareFeaturesCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FeatureGroup",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "featureGroupTitleExternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "limit",
              "value": 20
            }
          ],
          "concreteType": "FeatureGroupFeaturesCollection",
          "kind": "LinkedField",
          "name": "featuresCollection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Feature",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                (v17/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "featureNameExternal",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FeatureDescription",
                  "kind": "LinkedField",
                  "name": "description",
                  "plural": false,
                  "selections": (v8/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FeatureRelevantPlanCollection",
                  "kind": "LinkedField",
                  "name": "relevantPlanCollection",
                  "plural": false,
                  "selections": (v21/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "relevantUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": (v13/*: any*/),
                  "concreteType": "FeatureFeatureAdditionalInformationCollection",
                  "kind": "LinkedField",
                  "name": "featureAdditionalInformationCollection",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FeatureAdditionalInformation",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "featureAdditionalInformation",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": (v13/*: any*/),
                          "concreteType": "FeatureAdditionalInformationRelevantPlanCollection",
                          "kind": "LinkedField",
                          "name": "relevantPlanCollection",
                          "plural": false,
                          "selections": (v21/*: any*/),
                          "storageKey": "relevantPlanCollection(limit:15)"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "featureAdditionalInformationCollection(limit:15)"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "featuresCollection(limit:20)"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "compareFeaturesCollection(limit:10)"
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "getMoreDetailsTitle",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": (v13/*: any*/),
  "concreteType": "PricingAdditionalDetailsCollection",
  "kind": "LinkedField",
  "name": "additionalDetailsCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PlanDetails",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "planAdditionalDetailsTitleExternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PlanDetailsPlanAdditionalDetails",
          "kind": "LinkedField",
          "name": "planAdditionalDetails",
          "plural": false,
          "selections": (v8/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "additionalDetailsCollection(limit:15)"
},
v25 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 1
    }
  ],
  "concreteType": "PricingRelatedProductCollection",
  "kind": "LinkedField",
  "name": "relatedProductCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductName",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productNameId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "relatedProductCollection(limit:1)"
},
v26 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaTitleExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "valueProposition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaText",
      "storageKey": null
    },
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Asset",
      "kind": "LinkedField",
      "name": "ctaAsset",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CallToAction",
  "abstractKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v28 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Plan",
    "kind": "LinkedField",
    "name": "items",
    "plural": true,
    "selections": [
      (v11/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": (v13/*: any*/),
        "concreteType": "PlanMicroCtaCollection",
        "kind": "LinkedField",
        "name": "microCtaCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v27/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "microCtaCollection(limit:15)"
      },
      (v16/*: any*/),
      (v18/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "pricingPageRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "PricingCollection",
        "kind": "LinkedField",
        "name": "pricingCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Pricing",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "PricingComparePlansCollection",
                "kind": "LinkedField",
                "name": "comparePlansCollection",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": "comparePlansCollection(limit:10)"
              },
              (v20/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "PricingCallToActionContainerCollection",
                "kind": "LinkedField",
                "name": "callToActionContainerCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v26/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "callToActionContainerCollection(limit:10)"
              },
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "PricingDatacenterPlansCollection",
                "kind": "LinkedField",
                "name": "datacenterPlansCollection",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": "datacenterPlansCollection(limit:10)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "pricingPageRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "PricingCollection",
        "kind": "LinkedField",
        "name": "pricingCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Pricing",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "PricingComparePlansCollection",
                "kind": "LinkedField",
                "name": "comparePlansCollection",
                "plural": false,
                "selections": (v28/*: any*/),
                "storageKey": "comparePlansCollection(limit:10)"
              },
              (v20/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "PricingCallToActionContainerCollection",
                "kind": "LinkedField",
                "name": "callToActionContainerCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v27/*: any*/),
                      (v26/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "callToActionContainerCollection(limit:10)"
              },
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "PricingDatacenterPlansCollection",
                "kind": "LinkedField",
                "name": "datacenterPlansCollection",
                "plural": false,
                "selections": (v28/*: any*/),
                "storageKey": "datacenterPlansCollection(limit:10)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "93590f1d3eb68265fc67bf3fd6183c1f",
    "id": null,
    "metadata": {},
    "name": "pricingPageRelayQuery",
    "operationKind": "query",
    "text": "query pricingPageRelayQuery(\n  $limit: Int = 1\n  $productNameId: String!\n  $locale: String!\n  $pricingTitleInternal: String = null\n  $skipSeoFields: Boolean = false\n) {\n  pricingCollection(limit: $limit, where: {relatedProduct: {productNameId_contains: $productNameId}, pricingTitleInternal_contains: $pricingTitleInternal}, locale: $locale) {\n    items {\n      pricingTitleInternal\n      pricingTitleExternal @skip(if: $skipSeoFields)\n      pageDescription @skip(if: $skipSeoFields)\n      headline {\n        json\n      }\n      comparePlansCollection(limit: 10) {\n        items {\n          planTitleExternal\n          planOneLiner\n          microCtaCollection(limit: 15) {\n            items {\n              __typename\n              ... on CallToActionMicrocopy {\n                ctaMicrocopyTitleExternal\n                ctaButtonText\n                ctaUrl\n              }\n            }\n          }\n          highlightedFeaturesTitle\n          highlightedFeaturesContainerCollection(limit: 15) {\n            items {\n              highlightedFeatureDetails {\n                json\n              }\n              highlightedFeatureTitleExternal\n              callOut\n            }\n          }\n        }\n      }\n      compareFeaturesTitle\n      compareFeaturesCollection(limit: 10) {\n        items {\n          featureGroupTitleExternal\n          featuresCollection(limit: 20) {\n            items {\n              callOut\n              featureNameExternal\n              description {\n                json\n              }\n              relevantPlanCollection {\n                items {\n                  planTitleExternal\n                }\n              }\n              relevantUrl\n              featureAdditionalInformationCollection(limit: 15) {\n                items {\n                  featureAdditionalInformation\n                  relevantPlanCollection(limit: 15) {\n                    items {\n                      planTitleExternal\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      getMoreDetailsTitle\n      additionalDetailsCollection(limit: 15) {\n        items {\n          planAdditionalDetailsTitleExternal\n          planAdditionalDetails {\n            json\n          }\n        }\n      }\n      relatedProductCollection(limit: 1) {\n        items {\n          productName\n          productNameId\n        }\n      }\n      callToActionContainerCollection(limit: 10) {\n        items {\n          __typename\n          ... on CallToAction {\n            ctaTitleExternal\n            valueProposition\n            ctaText\n            ctaUrl\n            ctaAsset {\n              title\n              description\n              url\n            }\n          }\n          ... on CallToActionMicrocopy {\n            ctaMicrocopyTitleExternal\n            ctaButtonText\n            ctaUrl\n          }\n        }\n      }\n      datacenterPlansCollection(limit: 10) {\n        items {\n          planTitleExternal\n          planOneLiner\n          microCtaCollection(limit: 15) {\n            items {\n              __typename\n              ... on CallToActionMicrocopy {\n                ctaMicrocopyTitleExternal\n                ctaButtonText\n                ctaUrl\n              }\n            }\n          }\n          highlightedFeaturesTitle\n          highlightedFeaturesContainerCollection(limit: 15) {\n            items {\n              highlightedFeatureDetails {\n                json\n              }\n              highlightedFeatureTitleExternal\n              callOut\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f0b024f23898a201517a855bfe7f282e";

export default node;
